import React, { ReactNode } from 'react';
import Fallback from 'router/Fallback';
import { useAuth } from '../auth/AuthProvider';

interface IPrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: IPrivateRouteProps) => {
  const { isAuthenticated, state } = useAuth();

  if (state.isLoading) {
    return <Fallback />;
  }

  if (!isAuthenticated) {
    return <Fallback />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
